import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-100236d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tiles-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-overline mb-1",
  style: {"visibility":"hidden"}
}, "filler", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Cumulative Number of Turns", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " Over the last 28 days ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-overline mb-1",
  style: {"visibility":"hidden"}
}, "filler", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Cumulative Number of Acceptances", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " Over the last 28 days ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Total Acceptances | Total Turns Count", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Total Active Copilot Chat Users", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Line = _resolveComponent("Line")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_card, {
        elevation: "4",
        color: "white",
        variant: "elevated",
        class: "mx-auto my-3",
        style: {"width":"300px","height":"175px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_2,
                _hoisted_3,
                _hoisted_4,
                _createElementVNode("p", null, _toDisplayString(_ctx.cumulativeNumberTurns), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        elevation: "4",
        color: "white",
        variant: "elevated",
        class: "mx-auto my-3",
        style: {"width":"300px","height":"175px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _createElementVNode("p", null, _toDisplayString(_ctx.cumulativeNumberAcceptances), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_main, {
      class: "p-1",
      style: {"min-height":"300px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          style: {"min-height":"300px"},
          class: "px-4 elevation-2"
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createVNode(_component_Line, {
              data: _ctx.totalNumberAcceptancesAndTurnsChartData,
              options: _ctx.chartOptions
            }, null, 8, ["data", "options"]),
            _hoisted_9,
            _createVNode(_component_Bar, {
              data: _ctx.totalActiveCopilotChatUsersChartData,
              options: _ctx.totalActiveChatUsersChartOptions
            }, null, 8, ["data", "options"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}